
export const blogData = [
    {
        id: 1,
        title: 'Seva The Food Sharing',
        description: 'We have made Seva The food sharing website as project of our construct week at Masai School.',
        date: 'Nov 13, 2021',
        image: 'https://user-images.githubusercontent.com/76626095/141648665-be7044d1-4696-44ab-9c40-24bfe527ddde.png',
        url: 'https://medium.com/@rohitkrrt/seva-the-food-sharing-64fe51a8dccc'
    },
    {
        id: 2,
        title: 'Purplle clone',
        description: 'Cloning of purplle.com website in just 6 days using HTML ,CSS and JS',
        date: 'Aug 29, 2021',
        image: 'https://miro.medium.com/max/1400/1*raI92y3S6aFYZGna4JxPbg.png',
        url: 'https://medium.com/@shaistasulthana78/cloning-of-purplle-com-website-in-just-6-days-using-html-css-and-js-845ce38f71cc'
    },
    {
        id: 3,
        title: 'Purplle clone using Backend',
        description: 'purplle.com is Ecommerce website which sells cosmetic produtcs online. Through this website we can order any cosmetics related to men and women are available in the website.',
        date: 'Oct 03, 2020',
        image: 'https://miro.medium.com/max/1400/1*raI92y3S6aFYZGna4JxPbg.png',
        url: 'https://medium.com/@shaistasulthana78/cloning-purplle-com-website-fda2c3f3914c'
    },
    // {
    //     id: 4,
    //     title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
    //     description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
    //     date: 'Sep 17, 2020',
    //     image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
    //     url: 'https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html'
    // },
    // {
    //     id: 5,
    //     title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
    //     description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
    //     date: 'Oct 1, 2020',
    //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
    //     url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
    // },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/